import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiGoneError extends TmApiClientError {
  public name = 'TmApiGoneError'

  protected override code: TmTransportHttpErrorCode = 410
}
